<script lang="ts">
    import { link } from "svelte-routing"
    import { apiBaseURL } from "../../config"

    import AudioFiles from "../page/AudioFiles.svelte"
    import Galleries from "./Galleries.svelte"

    export let article
    export let id
</script>

<article class="article-details col-md-{article.columns}">
    <div class="article-content variant-{article.variant}">
        {#if article.title}
            <h2 class="article-title mb-lg">
                {article.title}
            </h2>
        {/if}
        {#if article.subtitle}
            <div class="article-subtitle">
                {article.subtitle}
            </div>
        {/if}

        {#if article.layout === 3}
            <div class="mb-lg">
                {#if article?.images?.length || article?.galleries?.length}
                    {#each article?.images as image}
                        <img
                            class="layout-{article.layout}"
                            src="{apiBaseURL}articles/{id}/{image.file.src}"
                            alt="{image.label}"
                        />
                    {/each}
                    {#if article?.galleries?.length}
                        <div class="mb-lg">
                            <Galleries article="{article}" />
                        </div>
                    {/if}
                {/if}
                {#if article?.audioFiles}
                    <AudioFiles article="{article}" id="{id}" />
                {/if}
            </div>
        {/if}

        <div>
            {#if article.layout === 1 || article.layout === 2}
                {#each article.images as image}
                    <img
                        class="layout-{article.layout}"
                        src="{apiBaseURL}articles/{id}/{image.file.src}"
                        alt="{image.label}"
                    />
                {/each}
            {/if}
            {#if article.text}
                <div class="article-content">
                    {@html article.text}
                </div>
            {/if}
        </div>

        {#if article.button_url}
            <a class="article-link" href="{article.button_url}" use:link>
                {article.button_text}
            </a>
        {/if}
    </div>

    {#if article.layout === 4}
        <div>
            {#each article.images as image}
                <img
                    class="layout-{article.layout}"
                    src="{apiBaseURL}articles/{id}/{image.file.src}"
                    alt="{image.label}"
                />
            {/each}
            {#if article?.galleries}
                <div class="mt-lg">
                    <Galleries article="{article}" />
                </div>
            {/if}
            {#if article?.audioFiles}
                <AudioFiles article="{article}" id="{id}" />
            {/if}
        </div>
    {/if}
</article>
